import { gql } from '@apollo/client'

export const UNVERIFY_CLASSIFICATION_BATCH = gql`
  mutation UnverifyClassificationBatch($batchId: ID!, $feedbackNote: String) {
    unverifyClassificationBatch(
      batchId: $batchId
      feedbackNote: $feedbackNote
    ) {
      __typename
      ... on ReviewUnverifyResult {
        success
      }
      ... on LeaseLockError {
        code
        message
      }
      ... on NoItemsAvailableError {
        code
        message
      }
    }
  }
`
